
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStockApproveSetAssembleDtGrid extends Serenity.EntityGrid<IcStockApproveSetAssembleDtRow, any> {
        protected getColumnsKey() { return IcStockApproveSetAssembleDtColumns.columnsKey; }
        protected getDialogType() { return IcStockApproveSetAssembleDtDialog; }
        protected getIdProperty() { return IcStockApproveSetAssembleDtRow.idProperty; }
        protected getInsertPermission() { return IcStockApproveSetAssembleDtRow.insertPermission; }
        protected getLocalTextPrefix() { return IcStockApproveSetAssembleDtRow.localTextPrefix; }
        protected getService() { return IcStockApproveSetAssembleDtService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}